<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                '样品款号/样品名称(中/英文)/产品线搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" size="small" :model="form" label-width="130px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_sampleSource') || '样品来源'">
              <dict-select
                :placeholder="$l('pe_select_sampleSource') || '请选择样品来源'"
                size="small"
                clearable
                filterable
                v-model="form.sampleSource"
                :body="{ dictType: 'sampleSource' }"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_business_name') || '业务人员'"
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_label_please_select_a_business_person') ||
                  '请选择业务人员'
                "
                :selectedLabel.sync="formData.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_productLine') || '产品线'"
              >
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('pe_tips_select_productLine') ||
                      '请选择产品线'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.productLine"
                    :body="productLineParams"
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('pe_select_Level_1_sample_classification') ||
                      '请选择1级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.masterCategoryCode"
                    :body="queryMasterCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    :placeholder="
                      $l('pe_select_Level_2_sample_classification') ||
                      '请选择2级样品分类'
                    "
                    size="small"
                    clearable
                    filterable
                    v-model="form.categoryCode"
                    :body="queryCategoryParams"
                    url="/master/masterCategory/select"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_designer') || '设计师'">
              <dict-select
                clearable
                v-model="form.designerCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('please_select_designer') ||
                  '请选择设计师'
                "
                :selectedLabel.sync="formData.designerName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sample_name_cn') || '样品中文名称'"
            >
              <el-input
                v-model.trim="form.sampleName"
                :placeholder="
                  $l('form_label_pe_input_sampleNamecn') || '请输入样品中文名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('from_label_sample_style_no') || '样品款号'"
            >
              <el-input
                v-model.trim="form.sampleStyleNo"
                :placeholder="
                  $l('form_label_pe_input_sample_style_no') || '请输入样品款号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sample_composition') || '样品成分'"
            >
              <el-input
                v-model="form.sampleMetadata"
                :placeholder="
                  $l('form_label_pe_input_sample_composition') ||
                  '请输入样品成分'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
            <!-- <dict-select
                :placeholder="'样品成分'"
                size="small"
                clearable
                filterable
                multiple
                v-model="form.sampleMetadataList"
                url="/digitalCenter/common/dict/sample/metadata/options"
                :options="{ label: 'label', value: 'label' }"
              ></dict-select> -->
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_factory') || '成品工厂'">
              <dict-select
                :placeholder="$l('pe_select_factory') || '请选择成品工厂'"
                size="small"
                clearable
                filterable
                multiple
                v-model="form.scmCodeList"
                url="/master/common/dict/scm"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_factory_product_number') || '工厂产品编号'"
            >
              <el-input
                v-model.trim="form.scmProductNo"
                :placeholder="
                  $l('pe_select_factory_product_number') || '请输入工厂产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('form_label_customer') || '客户'"
            >
              <dict-select
                v-model="form.custCodeList"
                clearable
                filterable
                multiple
                url="/master/common/dict/customerSelect"
                :placeholder="
                  $l('please_select_a_customer') ||
                  '请选择客户'
                "
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('form_label_brand') || '品牌'"
            >
              <dict-select
                clearable
                v-model="form.brandCode"
                filterable
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('please_select_brand') || '请选择品牌'
                "
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_customerProductNo') || '客人产品编号'"
            >
              <el-input
                v-model="form.customerProductNo"
                :placeholder="
                  $l('pe_select_customerProductNo') || '请输入客人产品编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_quotation_method') || '报价方式'"
              prop="quotedMethod"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.quotedMethod"
                :body="{ dictType: 'quotedMethod' }"
                :placeholder="
                  $l('pe_select_quotation_method') || '请选择报价方式'
                "
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_moq') || '起订量'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_moqStart') || '请输入起订量'
                    "
                    v-model="form.moqStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_moqEnd') || '请输入起订量'
                    "
                    v-model="form.moqEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="
                        $l('pe_select_moqUnit') || '请选择起订量单位'
                      "
                      size="small"
                      clearable
                      filterable
                      v-model="form.moqUnit"
                      :body="moqUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_costPrice') || '单价'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_costPriceStart') || '请输入成本价'
                    "
                    v-model="form.costPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_costPriceEnd') || '请输入成本价'
                    "
                    v-model="form.costPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      :placeholder="
                        $l('form_label_costCurrency') || '请选择货币单位'
                      "
                      size="small"
                      clearable
                      filterable
                      v-model="form.costCurrency"
                      :body="currencyUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_quotedPrice') || '建议报价'">
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_quotedPriceStart') || '请输入建议报价'
                    "
                    v-model="form.quotedPriceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    :placeholder="
                      $l('pe_input_quotedPriceEnd') || '请输入建议报价'
                    "
                    v-model="form.quotedPriceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    size="small"
                    clearable
                    filterable
                    v-model="form.quotedCurrency"
                    :body="{ dictType: 'quotedCurrency' }"
                    :placeholder="
                      $l('pe_select_quotedCurrency') || '请选择建议报价币种'
                    "
                    url="/sys/common/dict/system"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('pe_select_modifyTimeStart') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('pe_select_modifyTimeEnd') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  productLineList: [],
  scmCodeList: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      dialogAddFormVisible: false,
      formData: {},
      form: { ...initForm },
      productLineParams: { dictType: 'productLine' },
      queryMasterCategoryParams: { parentCode: 'x' },
      queryCategoryParams: { parentCode: 'x' },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      mainMaterialParams: { parentCode: '' },
      detailMaterialParams: { masterCategoryCode: '' },
    }
  },
  watch: {
    // 新增弹框下拉
    'formData.productLine'() {
      this.masterCategoryParams = { parentCode: this.formData.productLine }
      this.formData.masterCategoryCode = ''
    },
    // 查询条件下拉
    'form.productLine'() {
      this.form.masterCategoryCode = ''
      this.form.categoryCode = ''
      this.queryCategoryParams = { parentCode: '' }
      this.queryMasterCategoryParams = { parentCode: this.form.productLine }
    },
    'form.masterCategoryCode'() {
      this.form.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.form.masterCategoryCode,
      }
    },
  },

  mounted() {
    this.$emit('reset')
    this.query()
  },
  activated() {
    // 页面切换回来后不执行刷新业务
    // this.$emit("reset");
    // this.query();
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query() {
      this.dialogVisible = false
      this.$emit('submit', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        productLineList: [],
        scmCodeList: [],
      }
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
      this.dialogAddFormVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
